<template>
  <spinner-container :loading="localLoading">
    <back-btn />
    <v-container>
      <v-row justify="center">
        <v-col class="col--padding" lg="8">
          <v-card class="card--shadow mb-2">
            <v-card-text>
              <patient-info :patient="patient" />
            </v-card-text>
          </v-card>
          <info-form :patient="patient" />
        </v-col>
      </v-row>
    </v-container>
  </spinner-container>
</template>

<script>
import InfoForm from "@/components/patient/enroll/InfoForm";
import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import PatientInfo from "../component/patientInfo.vue";

export default {
  components: {
    InfoForm,
    BackBtn,
    SpinnerContainer,
    PatientInfo,
  },
  data: () => ({}),
  computed: {
    ...mapState("Patient", ["patient"]),
    ...mapState("Loading", ["localLoading"]),
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store
      .dispatch("Patient/getPatient", this.$route.params.patientId)
      .then(() => {
        this.$store.dispatch("Loading/changeLocalLoading");
      });
  },
};
</script>
